import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";

export type SortType = 0 | 1

export interface ICarLine {
  id: number
  title: string
  code: string
  status: number
}

export interface ICarLineEdit {
  id: number
  title: string
  categoryCarId: number
  carLinesId: number
  code: string
}
export interface ICarLineEditV2 {
  id: number
  title: string
}
export const getListCarLine = async (
  limit?: number, pageNumber?: number, searchNameCategoryCar?: string) => {
  const path = "carLines/listCarLines"
  const params = {
    limit, pageNumber, searchNameCategoryCar
  }
  const result: ResponseSuccessTotal<ICarLine[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin dòng xe
export const getInfoCarLine = async (
  id: number
) => {
  const path = "carLines/infoCarLines"
  const params = {
    id
  }
  const result: ResponseSuccess<ICarLine> = await axiosClient.get(
    path, { params }
  );
  return result;
};


//Thêm mới dòng xe
export const addCarLines = async (
  title: string, code: string
) => {
  const url = `carLines/addCarLines`;
  const params = {
    title, code
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Chỉnh sửa dòng xe
export const editCarLines = async (
  idCarlines: number, code: string, title: string
) => {
  const url = `carLines/editCarLines`;
  const params = {
    idCarlines, code, title
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

//Xóa dòng xe
export const deleteCarLines = async (
  id: Number
) => {
  const url = `carLines/deleteCarLines`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}

export const updateActiveCarLine = async (
  id: number
) => {
  const path = "carLines/activeCarLines"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  );
  return result;
};
